import { Component, OnInit } from '@angular/core';
import { AuthService } from '@services/auth.service';

@Component({
    template: `
    <div class="container">
      <div class="loader">
        <svg class="loader__logo" style="fill:none" viewBox="0 0 256 256">
          <path
            class="logo-path logo-thin"
            d="M127.4,228c-13.4,0-34.1-15.4-54.1-40.1c-20.7-25.6-35.7-55-40.1-78.6c-3.7-20.2,5.3-35.7,13.6-45.1C57.1,52.5,70.2,45,79.1,41.8c11.3-4,40.6-13.3,69.8-13.7c3.8-0.1,6.9-0.1,9.7-0.1c30.2,0,47.1,3.4,56,22.2c6.1,12.8,7.8,30.3,4.9,50.5c-2.7,19-9.2,39.1-18.8,58.4c-8.8,17.6-19.6,33.2-31.2,45c-12.6,12.8-26.1,21-38.9,23.6C129.6,227.9,128.5,228,127.4,228z" />
          <path
            class="logo-path logo-thick"
            d="M134.9,33.5c-19.5,0-36.7,2.5-45.2,4c-9.2,1.6-23.3,6.7-35.1,16.3C45,61.4,33.8,74.7,34.2,94.3c0.6,24.1,11.1,55.4,28.3,83.7c7.9,13,16.4,24,24.6,31.8c8.6,8.2,16.5,12.6,22.9,12.6c0.2,0,0.4,0,0.6,0c13.4-0.6,28.3-6.6,43.1-17.4c13.8-10,27.2-23.9,38.7-40.1c11.9-16.6,20.9-34.5,26.2-51.6c5.6-18.2,6.6-34.5,2.8-47.2c-6.4-21.6-27.2-26.1-60.7-30.8C152.7,34.1,144.1,33.5,134.9,33.5z" />
        </svg>
      </div>
    </div>
  `,
    styles: [
        `
      .container {
        width: 100%;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;

        .loader {
          position: relative;
          display: flex;
          visibility: visible;
          animation: fadeIn 1s forwards reverse;
        }

        svg.loader__logo {
          width: 128px;
          height: 128px;
          stroke-width: 0.04rem;
          display: inline-block;
          vertical-align: top;
          margin: auto;
        }

        svg.loader__logo .logo-thin,
        svg.loader__logo .logo-thick {
          fill: none;
          stroke: rgb(0, 172, 213);
          stroke-linecap: round;
        }

        svg.loader__logo .logo-thin {
          stroke-width: 0.075rem;
          stroke-dasharray: 305, 305;
          stroke-dashoffset: 1220;
          animation: thinstrokearray 3.2s linear infinite, strokeoffset 3.2s linear infinite;
        }

        svg.loader__logo .logo-thick {
          stroke-width: 0.2rem;
          stroke-dasharray: 300, 300;
          stroke-dashoffset: -1200;
          animation: thickstrokearray 6s linear infinite, strokeoffset 6s linear infinite;
        }

        @keyframes strokeoffset {
          100% {
            stroke-dashoffset: 0;
          }
        }

        @keyframes thinstrokearray {
          50% {
            stroke-dasharray: 61, 550;
          }
        }

        @keyframes thickstrokearray {
          60% {
            stroke-dasharray: 60, 541;
          }
        }

        @keyframes fadeIn {
          80% {
            opacity: 0;
          }

          100% {
            opacity: 0;
          }
        }
      }
    `,
    ],
    standalone: false
})
export class CallbackComponent implements OnInit {
  constructor(private readonly authService: AuthService) {}

  ngOnInit() {
    this.authService.handleCallback();
  }
}
